

export const workspaceAttributes = {
    cs: '10% 20% 20% 20% 15% 15%',
    headers: [
        { title: 'name' },
        { title: 'code' },
        { title: 'is-verified' },
        { title: 'is-active' },
        { title: 'date', sort: 'createdAt' }
    ]
}

export const withdrawListAttributes = {
    cs: '5% 30% 15% 15% 15% 15% 5%',
    headers: [
        { title: 'creator' },
        { title: 'currency' },
        { title: 'total' },
        { title: 'withdraw-status' },
        { title: 'date' }
    ]
}

export const withdrawDetailAttributes = {
    cs: '40% 20% 20% 20%',
    headers: [
        { title: 'user' },
        { title: 'has-approve' },
        { title: 'approved' },
        { title: 'share' },
    ]
}

export const contractAttributes = {
    cs: '5% 20% 15% 15% 20% 25%',
    headers: [
        { title: 'name' },
        { title: 'is-active' },
        { title: 'is-delete' },
        { title: 'date', sort: 'createdAt' }
    ]
}

export const blockedAttributes = {
    cs: '5% 35% 35% 25%',
    headers: [
        { title: 'blocker' },
        { title: 'blocked' },
        { title: 'date', sort: 'createdAt' }
    ]
}

export const attachmentAttributes = {
    cs: '5% 35% 20% 20% 20%',
    headers: [
        { title: 'name' },
        { title: 'size' },
        { title: 'user' },
        { title: 'date', sort: 'createdAt' },
    ]
}

export const paymentAttributes = {
    cs: '5% 10% 15% 10% 15% 10% 10% 10% 10% 5%',
    headers: [
        { title: 'name' },
        { title: 'currency' },
        { title: 'amount' },
        { title: 'payment-status' },
        { title: 'needApprove' },
        { title: 'payment-isActive' },
        { title: 'dueDate', sort: 'dueDate' },
        { title: 'date', sort: 'createdAt' }
    ]
}

export const otcOrdersAttributes = {
    cs: '4% 15% 10% 10% 12% 12% 12% 10% 10% 5%',
    headers: [
        { title: 'name' },
        { title: 'coin' },
        { title: 'amount', sort: 'amount' },
        { title: 'wage', sort: 'wage' },
        { title: 'unitPrice', sort: 'priceUnit' },
        { title: 'price', sort: 'price' },
        { title: 'transaction-type' },
        { title: 'traded-date', sort: 'tradedAt' }
    ]
}

export const tradeAttributes = {
    cs: '5% 14% 14% 10% 8% 10% 10% 8% 8% 8% 5%',
    headers: [
        { title: 'maker' },
        { title: 'taker' },
        { title: 'market' },
        { title: 'trade-type' },
        { title: 'amount', sort: 'amount' },
        { title: 'unitPrice', sort: 'priceUnit' },
        { title: 'price', sort: 'price' },
        { title: 'transaction-type' },
        { title: 'date', sort: 'createdAt' }
    ]
}

export const userAttributes = {
    cs: '5% 20% 15% 15% 15% 15% 10% 5%',
    headers: [
        { title: 'email' },
        { title: 'user-code' },
        { title: 'type' },
        { title: 'role' },
        { title: 'ga' },
        { title: 'user-is-active' }
    ]
}


export const cartableAttributes = {
    cs: '5% 15% 20% 15% 15% 15% 10% 5%',
    headers: [
        { title: 'currency' },
        { title: 'askById' },
        { title: 'volume' },
        { title: 'action' },
        { title: 'status' },
        { title: 'date', sort: 'createdAt' }
    ]
}

export const walletAttributes = {
    cs: '5% 20% 20% 15% 15% 15% 10%',
    headers: [
        { title: 'user' },
        { title: 'address' },
        { title: 'coin' },
        { title: 'network' },
        { title: 'amount', sort: 'amount' },
        { title: 'type' },
    ]
}

export const fileAttributes = {
    cs: '5% 40% 18% 18% 12% 8%',
    headers: [
        { title: 'file-name' },
        { title: 'file-type' },
        { title: 'file-status' },
        { title: 'date', sort: 'createdAt' },
    ]
}

export const coinTransactionAttributes = {
    cs: '5% 15% 15% 15% 15% 15% 15% 5%',
    headers: [
        { title: 'name' },
        { title: 'coin' },
        { title: 'amount', sort: 'amount' },
        { title: 'transaction-type' },
        { title: 'transaction-status' },
        { title: 'date', sort: 'createdAt' },
    ]
}


export const bankTransactionAttributes = {
    cs: '5% 20% 17% 17% 16% 20% 5%',
    headers: [
        { title: 'name' },
        { title: 'amount', sort: 'amount' },
        { title: 'transaction-type' },
        { title: 'transaction-status' },
        { title: 'date', sort: 'createdAt' },
    ]
}


export const wagesAttributes = {
    cs: '5% 25% 25% 20% 20% 5%',
    headers: [
        { title: 'coin' },
        { title: 'count' },
        { title: 'amount' },
        { title: 'wages' }
    ]
}

export const traceAttributes = {
    cs: '5% 20% 10% 10% 10% 10% 10% 10% 15%',
    headers: [
        { title: 'entityId' },
        { title: 'entityType' },
        { title: 'currency' },
        { title: 'amount', sort: 'amount' },
        { title: 'wage', sort: 'wage' },
        { title: 'cause' },
        { title: 'action' },
        { title: 'date', sort: 'createdAt' },
    ]
}


export const affiliateListAttribute = {
    cs: '5% 15% 12% 12% 11% 25% 12% 8%',
    headers: [
        { title: 'name' },
        { title: 'affiliate-code' },
        { title: 'use-count', sort: 'used' },
        { title: 'max-use', sort: 'maxUse' },
        { title: 'share' },
        { title: 'date', sort: 'createdAt' },
    ]
}


export const affiliateTraceAttribute = {
    cs: '5% 20% 35% 35% 5%',
    headers: [
        { title: 'coin' },
        { title: 'actor-share' },
        { title: 'object-share' },
    ]
}

export const addressAttributes = {
    cs: '5% 10% 20% 15% 35% 15%',
    headers: [
        { title: 'name' },
        { title: 'user' },
        { title: 'coin' },
        { title: 'address' },
        { title: 'date', sort: 'createdAt' },
    ]
}

export const availableBanksAttributes = {
    cs: '5% 25% 25% 25% 20%',
    headers: [
        { title: 'symbol' },
        { title: 'en-name' },
        { title: 'fa-name' },
        { title: 'ab-status' },
    ]
}

export const thirdBalanceAttributes = {
    cs: '5% 20% 20% 20% 20% 15%',
    headers: [
        { title: 'coin' },
        { title: 'type' },
        { title: 'balance' },
        { title: 'available' },
        { title: 'holds' },
    ]
}


export const pairAttributes = {
    cs: '5% 30% 30% 30% 5%',
    headers: [
        { title: 'coin' },
        { title: 'en-name' },
        { title: 'fa-name' }
    ]
}


export const roleAttributes = {
    cs: '5% 10% 70% 10% 5%',
    headers: [
        { title: 'name', sort: 'name' },
        { title: 'permissions' },
        { title: 'date', sort: 'createdAt' }
    ]
}


export const tokenAttributes = {
    cs: '5% 15% 15% 15% 15% 15% 15% 5%',
    headers: [
        { title: 'token' },
        { title: 'blockchain', sort: 'name' },
        { title: 'network' },
        { title: 'decimal', sort: 'decimal' },
        { title: 'is-active' },
        { title: 'is-available' }
    ]
}

export const availableCoinsWDListAttributes = {
    cs: "5% 15% 10% 14% 10% 10% 10% 10% 8% 8%",
    headers: [
        { title: "name" },
        { title: "network" },
        { title: "min" },
        { title: "max" },
        { title: "fee-factor" },
        { title: "fee-min" },
        { title: "fee-max" },
        { title: "delay" },
        { title: "isActive" }
    ]
}
